import { render, staticRenderFns } from "./project-restrict-user.vue?vue&type=template&id=628fdee4&"
import script from "./project-restrict-user.vue?vue&type=script&lang=js&"
export * from "./project-restrict-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports